import React from 'react';

import {Modal, message} from 'antd';

import fetch from './fetch';
import utils from './../utils';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},

    {key:'name', label: '文件名称'},
    {key:'logicPath', label: '文件路径'},
    {key:'fileNumber', label: '文件字号'},
    {key:'publishOrgName', label: '发文部门'},
    {key:'publishDate', label: '发布日期', render: (value)=> moment(new Date(value)).format('YYYY/MM/DD')},
    {key:'realName', label: '上传人'},
    {key:'fileDesc', label: '关键字'},
    {key:'termName', label: '所属学期/学年'},
    {type:'action', label: '操作', values: ['read', 'down', 'file']},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100, }) => {
    return fetch.post('/classroom/analysis/data/information', keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    });
}


export default {
    querySearch,
    headers,
    onSelect,
    setRefresh
}
